import { DeviceStatus } from '../../dashboard/deviceStatus';
import { useDevicesState } from "../../../utilities/useDevicesState";
import Enum from '../../../utilities/enum';

export default function AllOrganisationCameras(props) {
    const { orderedCameras, getCameras, camerasLoading, exportCameras } = useDevicesState(props.organisationId, props.token);
    
    return (
        <div className="container-fluid">
            {                
                <DeviceStatus
                    orderedDevices={orderedCameras}
                    deviceType={Enum.DeviceType[0]}
                    viewAll
                    organisationId={props.organisationId}
                    token={props.token}
                    handleRefreshClick={getCameras}
                    isLoading={camerasLoading}
                    dangerThreshold={props.settings.cameraStatusDangerThreshold !== null ? props.settings.cameraStatusDangerThreshold : 30}
                    warningThreshold={props.settings.cameraStatusWarningThreshold !== null ? props.settings.cameraStatusWarningThreshold : 90}
                    handleExport={exportCameras}
                />                
            }
        </div>
    )
}